import React, { FC } from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

export const VisibleUpliftTooltip: FC<{ children?: React.ReactNode }> = ({ children }) => (
  <Tooltip
    title="Visible uplifts are applied as a percentage of the total after hidden uplifts are added."
    placement="left"
  >
    <InfoCircleOutlined style={{ marginLeft: "5px" }} />
    {children}
  </Tooltip>
);
